// Keep the same intent after a lost HTTP response, including a page reload.
const inflight = new Map<string, Promise<unknown>>();
export function printIntent<T>(scope: string, send: (key: string) => Promise<T>): Promise<T> {
  const storageKey = `scl:print-intent:${scope}`;
  const pending = inflight.get(storageKey);
  if (pending) return pending as Promise<T>;
  const key = sessionStorage.getItem(storageKey) || crypto.randomUUID();
  sessionStorage.setItem(storageKey, key);
  const promise = send(key).then(result => {
    sessionStorage.removeItem(storageKey);
    return result;
  }).finally(() => inflight.delete(storageKey));
  inflight.set(storageKey, promise);
  return promise;
}
